import React from 'react';
import styled from 'styled-components';

import { mobileLogger } from '@/utils/logger';

interface Props {
  children: JSX.Element;
  eventName: string;
  pageName: string;
  payload?: {
    [key: string]: string | number;
  };
}
const ClickEventLogger = ({
  children,
  eventName,
  pageName,
  payload,
}: Props) => {
  const onClickEventLog = () => {
    mobileLogger({
      logger: {
        eventName,
        pageName,
        payload,
      },
    });
  };
  return (
    <Wrapper role="button" onClick={onClickEventLog}>
      {children}
    </Wrapper>
  );
};

export default ClickEventLogger;

const Wrapper = styled.div``;
